import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';

import { Constants } from '@config/constants';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class AuthService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) {}

  login = (username: string, password: string): Observable<any> =>
    this.http
      .post<any>(this.constants.LOGIN_ENDPOINT, { username, password })
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );
}
